import { useConsumptionForm } from "@/features/consumption/hooks/useConsumptionForm";
import { FormProvider } from "react-hook-form";
import ModalPassword from "@/common/components/ModalPassword";
import ModalSuccess from "@/features/consumption/components/ModalSuccess";
import ModalError from "@/features/consumption/components/ModalError";
import { ConsumptionData, ConsumptionErrorResponseData } from "@/features/consumption/types/consumption.type";
import ConsumptionMobileInformationScreen from "./components/ConsumptionMobileInformationScreen";
import ConsumptionMobileResumeScreen from "./components/ConsumptionMobileResumeScreen";

const ConsumptionCreateMobile = () => {
  const {
    formMethods,
    activeTab,
    modalPasswordIsOpen,
    setModalPasswordIsOpen,
    modalSuccessData,
    setModalSuccessData,
    modalErrorData,
    setModalErrorData,
    createConsumptionIsPending,
    onSubmit,
    clearForm,
    handleTabChange,
  } = useConsumptionForm();

  return (
    <FormProvider {...formMethods}>
      {activeTab === 0 && (
        <ConsumptionMobileInformationScreen
          clearForm={clearForm}
          handleTabChange={handleTabChange}
        />
      )}

      {activeTab === 1 && (
        <ConsumptionMobileResumeScreen
          handleTabChange={handleTabChange}
          setModalPasswordIsOpen={setModalPasswordIsOpen}
          createConsumptionIsPending={createConsumptionIsPending}
        />
      )}

      <ModalPassword
        fieldName="consumtion_password"
        isOpen={modalPasswordIsOpen}
        setIsOpen={setModalPasswordIsOpen}
        submit={() => formMethods.handleSubmit(onSubmit)()}
      />

      <ModalSuccess
        data={modalSuccessData as ConsumptionData}
        setData={setModalSuccessData as React.Dispatch<React.SetStateAction<boolean>>}
        clearForm={clearForm}
      />

      <ModalError
        data={modalErrorData as ConsumptionErrorResponseData}
        setData={setModalErrorData as React.Dispatch<React.SetStateAction<boolean>>}
      />
    </FormProvider>
  );
}

export default ConsumptionCreateMobile;
